import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { skipWhile, map } from 'rxjs/operators';
import { findName } from '@flexus/utilities';
import { BigFormService } from '@flexus/core';

@Component({
	selector: 'flx-cancel-job',
	templateUrl: './cancel-job.component.html',
	styleUrls: ['./cancel-job.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FLXCancelJobComponent implements OnInit, OnDestroy {
	@Input() jobdata$: Observable<any>;
	@Input() heading: string;
	@Input() subtitle: string;
	@Input() organisation: string;

	public _job: any;
	keyvaldata$: Observable<any>;
	claimtype: string;
	claimTypes: any;
	claimant: string;
	currentstate: any;
	jobId: string;
	sub: Subscription;

	constructor(private bf: BigFormService, private cdr: ChangeDetectorRef) {}

	ngOnInit() {
		this.sub = this.jobdata$
			.pipe(
				skipWhile(data => !data),
				map(data => {
					return data;
				})
			)
			.subscribe(res => {
				//get al the required data elements to display
				// debugger;
				const { job, stor } = res;
				if (job) {
					this.jobId = job?.id;
					this.claimTypes = stor.allInfo.claim_types;
					this.claimtype = findName(job.claim?.claim_type, this.claimTypes).name;
					this.currentstate = findName(job.state, stor.allInfo.states)?.description;
					this.claimant = `${job.claim?.applicant?.first_name} ${job.claim?.applicant?.surname}`;
					this._job = job;
					this.keyvaldata$ = of([
						{
							claim_Type: this.claimtype,
							claimant: this.claimant,
							job_ID: this.jobId,
							current_state: this.currentstate
						}
					]);
					if (this.organisation === 'mul') {
						this.keyvaldata$ = of([
							{
								installation: this.claimtype,
								customer: this.claimant,
								job_ID: this.jobId,
								current_state: this.currentstate
							}
						]);
					}
				}
				this.cdr.detectChanges();
			});
	}
	ngOnDestroy() {
		if (this.sub) {
			this.sub.unsubscribe();
		}
	}
}
